import { StateSchema } from 'app/config/storeConfig/types';
import { LeadNoteDrawerSchema } from '../types';

export const getLeadNoteDrawerState = (state: StateSchema): LeadNoteDrawerSchema => state.leadNoteDrawer;
